import type { ClassSelectorState } from '@engage/classes/redux';
import { getClass } from '@engage/classes/redux';
import { getClassId } from '@engage/video/selectors';

export const maybeClass = (
  state: ClassSelectorState & Parameters<typeof getClassId>[0],
) => {
  const classId = getClassId(state);
  return classId && getClass(state, classId);
};
